import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-fatura-detalhes',
  templateUrl: './fatura-detalhes.component.html',
  styleUrls: ['./fatura-detalhes.component.scss']
})
export class FaturaDetalhesComponent implements OnChanges {
  @Input() fatura: any = {};
  gruposLancamentos: any[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fatura)
      this.agrupeLancamentosPorEmpresa();
  }

  get exibeLancamentosAgrupados(): boolean {
    return this.gruposLancamentos.length > 0;
  }

  private agrupeLancamentosPorEmpresa() {
    const grupos: any[] = [];
    const gruposPorEmpresa = new Map<string, any>();

    (this.fatura?.itensGrupo || []).forEach((item: any, indice: number) => {
      const empresaId = item?.empresa?.id;
      const chave = empresaId != null ? `empresa:${empresaId}` : `item:${indice}`;
      let grupo = gruposPorEmpresa.get(chave);

      if (!grupo) {
        grupo = {empresa: item?.empresa || {}, itens: []};
        gruposPorEmpresa.set(chave, grupo);
        grupos.push(grupo);
      }

      grupo.itens.push(item);
    });

    this.gruposLancamentos = grupos;
  }
}
